"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.C1C2Governance = exports.C1C2Augmented = exports.C1C2 = exports.C1C2InviteRequest = void 0;
const openapi_1 = require("../../../openapi");
class C1C2InviteRequest {
    c2Name;
    c2Email;
    c2CustomerId;
    governance;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], C1C2InviteRequest.prototype, "c2Name", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'email' })
], C1C2InviteRequest.prototype, "c2Email", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'integer' })
], C1C2InviteRequest.prototype, "c2CustomerId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => C1C2Governance)
], C1C2InviteRequest.prototype, "governance", void 0);
exports.C1C2InviteRequest = C1C2InviteRequest;
class C1C2 {
    c1OrgKey;
    c2OrgKey;
    c2CustomerId;
    disabled;
    governance;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], C1C2.prototype, "c1OrgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], C1C2.prototype, "c2OrgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'integer' })
], C1C2.prototype, "c2CustomerId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], C1C2.prototype, "disabled", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => C1C2Governance)
], C1C2.prototype, "governance", void 0);
exports.C1C2 = C1C2;
class C1C2Augmented extends C1C2 {
    c1DisplayName;
    c2DisplayName;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], C1C2Augmented.prototype, "c1DisplayName", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], C1C2Augmented.prototype, "c2DisplayName", void 0);
exports.C1C2Augmented = C1C2Augmented;
class C1C2Governance {
    enabledC2Permissions;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'array',
        items: { type: 'string' },
        description: 'Permissions the C2 is permitted to add to a role.',
    })
], C1C2Governance.prototype, "enabledC2Permissions", void 0);
exports.C1C2Governance = C1C2Governance;
